import { render, staticRenderFns } from "./YA_ImitateContent1.vue?vue&type=template&id=1a81740d&scoped=true"
import script from "./YA_ImitateContent1.vue?vue&type=script&lang=js"
export * from "./YA_ImitateContent1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a81740d",
  null
  
)

export default component.exports